import { useMatches, useNavigate, useSearchParams } from 'react-router-dom';
import { useEffectOnCloudChange } from '../../hooks/customer.hooks';

// it's temporary as it should be inside specific pages
// split.io triggers re-renders which causes re-building pages
export const RoutesEffects = ({ cloudName }: { cloudName: string }) => {
  const matches = useMatches();
  const isVideoPlayerReportsActive = !!matches.find(({ pathname }) => pathname.includes('/reports/video-player'));
  const isMediaExplorerActive = !!matches.find(({ pathname }) => pathname.includes('/media-explorer'));
  const [, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffectOnCloudChange(cloudName, () => {
    if (isVideoPlayerReportsActive) {
      setSearchParams('');
    }
    if (isMediaExplorerActive) {
      navigate('media-explorer');
    }
  });

  return null;
};
